import { h } from 'preact';
import clsx from 'clsx';
import { useState, useMemo } from 'preact/hooks';
import SubMenuItems from './submenu-items';
import SubMenuTabs from './submenu-tab';

const SubMenuContainer = ({
  menu,
  subMenuShowed,
  showShopAll,
  shopAllTitle,
  isVoyagesLayout,
}) => {
  const isTabsMenus = !!menu.find((m) => m.submenus.length > 0);
  const [activeTab, setActiveTab] = useState(0);
  const [activeMenu, setActiveMenu] = useState(menu[activeTab].submenus);

  const tabMenus = useMemo(
    () => (
        <SubMenuTabs
          menu={menu}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          activeMenu={activeMenu}
          setActiveMenu={setActiveMenu}
          isVoyagesLayout={isVoyagesLayout}
        />
    ),
    [activeMenu, activeTab],
  );

  return (
    <div
      className={clsx(
        'absolute w-full top-[100%] border-t left-0 transition-all overflow-hidden',
        subMenuShowed ? 'max-h-[1000px] opacity-100' : 'max-h-0 opacity-0',
        isVoyagesLayout ? 'border-white-50' : 'border-black-30',
      )}
    >
      <div
        className={clsx(
          '',
          isVoyagesLayout
            ? 'bg-[#3A3A3C] text-neutral'
            : 'bg-neutral text-charcoal pt-10 px-10',
        )}
      >
        {!isTabsMenus ? (
          <div className={clsx(
            'flex items-start justify-between ',
            isVoyagesLayout ? 'items-stretch' : 'gap-8 pb-10',
          )}>
            <SubMenuItems menu={menu} isVoyagesLayout={isVoyagesLayout} />
          </div>
        ) : (
          tabMenus
        )}
      </div>
      {showShopAll && (
        <div
          className={clsx(
            'text-center w-full pt-[18px] pb-5',
            isVoyagesLayout
              ? 'bg-[#3A3A3C] text-neutral'
              : 'bg-cream-grey text-black',
          )}
        >
          <a href={showShopAll?.url} className="cta-small uppercase underline">
            {window.TMW?.Strings?.header?.shopAll} {shopAllTitle}
          </a>
        </div>
      )}
    </div>
  );
};

export default SubMenuContainer;
